import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get saleReturnBranch
export const getSaleReturnBranch = createAsyncThunk(
  "saleReturnBranch/getSaleReturnBranch",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getSaleReturnBranch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all saleReturnBranch
export const getAllSaleReturnBranch = createAsyncThunk(
  "saleReturnBranch/getAllSaleReturnBranch",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllSaleReturnBranch();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("saleReturnBranch/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleReturnBranch/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleReturnBranch/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleReturnBranch({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getSaleReturnBranchById = createAsyncThunk(
  "saleReturnBranch/getSaleReturnBranchById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleReturnBranchById(id);
      if (data?.data?.salesOrderMain?.saleOrderDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data?.data?.salesOrderMain?.saleOrderDetails?.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return {
          ...data,
          data: { ...data.data, salesOrderMain: { ...data.data.salesOrderMain, saleOrderDetails: updatedDetails } },
        };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getSaleReturnBranchAdditionalChargeList = createAsyncThunk(
  "saleReturnBranch/getSaleReturnBranchAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleReturnBranchAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getSaleInvoiceDetail = createAsyncThunk(
  "saleReturnBranch/getSaleInvoiceDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getSaleInvoiceDetail(id);

      if (data?.data.saleInvoiceDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.saleInvoiceDetails.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, saleInvoiceDetails: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create saleReturnBranch
export const createSaleReturnBranch = createAsyncThunk(
  "saleReturnBranch/createSaleReturnBranch",
  async (createData, { rejectWithValue }) => {
    const {
      salesOrderInvoice,
      branch,
      partyAccount,
      refundAmount,
      remarks,
      salesOrderReturnDetails,
      saleOrderReturnAdditionalChargeCost,
      saleOrderReturnMainPartyDetails,
      saleOrderReturnMainVehicleDetail,
    } = createData;
    try {
      const body = JSON.stringify({
        salesOrderInvoice,
        branch,
        partyAccount,
        refundAmount,
        salesOrderReturnDetails,
        saleOrderReturnAdditionalChargeCost,
        saleOrderReturnMainPartyDetails,
        saleOrderReturnMainVehicleDetail,
        remarks,
      });

      const { data } = await API.createSaleReturnBranch(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateSaleReturnBranch = createAsyncThunk(
  "saleReturnBranch/updateSaleReturnBranch",
  async (params, { rejectWithValue }) => {
    const { id, values } = params;
    const {
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDate,
      branch,
      status,
      documentsAttach,
      // refVoucher,
      saleReturnBranchDetails,
      saleOrderReturnMainPartyDetails,
      saleOrderReturnMainVehicleDetail,
    } = values;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        status,
        voucherDate,
        // refVoucher,
        saleReturnBranchDetails,
        saleOrderReturnMainPartyDetails,
        saleOrderReturnMainVehicleDetail,
      });
      const { data } = await API.updateSaleReturnBranch(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const approveSaleReturnBranch = createAsyncThunk(
  "saleReturnBranch/approveSaleReturnBranch",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.approveSaleReturnBranch(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const cancelSaleReturnBranch = createAsyncThunk(
  "saleReturnBranch/cancelSaleReturnBranch",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.cancelSaleReturnBranch(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
// handle search
export const handleSearch = createAsyncThunk(
  "saleReturnBranch/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
